import { init as initDynamicForms } from '@app/pages/dynamic-form';
import { loader } from '@/js/utils/common';

loader(() => {
    initDynamicForms();
});
